<div>
    <h2>{{'mantenimientoRoyalties.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
          <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
            <label>{{'mantenimientoRoyalties.filters.entidadControl' | translate}} *</label>
            <app-filterable-list [itemsList]="entidadesControl" [selectedItem]="filtersForm.get('entidadControl')"
            [disabled]="disabledEntidadControl">
            </app-filterable-list>
          </div>
          <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
              <label>{{'global.pais' | translate}}</label>
              <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
                  [placeHolder]="false" [disabled]="disabledPaises"></app-filterable-list>
          </div>
          <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
              <label>{{'mantenimientoRoyalties.filters.denominacion' | translate}}</label>
              <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                  [placeHolder]="false" [disabled]="disabledDenominaciones"></app-filterable-list>
          </div>
          <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
              <label>{{'mantenimientoRoyalties.filters.marca' | translate}}</label>
              <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')"
              [placeHolder]="false" [disabled]="disabledMarcas"></app-filterable-list>
          </div>
          <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
          <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <content class="tabs">
      <form *ngIf="royalties">
        <h3>{{'mantenimientoRoyalties.unidadesMedida.titulo' | translate}}</h3>
        <section class="info-framed" *ngIf="unidadesMedida">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimientoRoyalties.unidadesMedida.moneda' | translate}}</label>
                <span>{{ unidadesMedida.divisas.des | translate}}</span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimientoRoyalties.unidadesMedida.superficie' | translate}}</label>
                <span>{{ unidadesMedida.superficie.des | translate}}</span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimientoRoyalties.unidadesMedida.plantas' | translate}}</label>
                <span>{{ unidadesMedida.nPlantas.des | translate}}</span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
              <label>{{'mantenimientoRoyalties.unidadesMedida.peso' | translate}}</label>
              <span>{{ unidadesMedida.peso.des | translate}}</span>
            </div>
        </section>
      </form>
      <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="id">{{'mantenimientoRoyalties.table.id' | translate}}</th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.EntidadControl.Des', 2)">
                          {{'mantenimientoRoyalties.table.entidadControl' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.EntidadControl.Des')"></i></div>
                        </th>
                        <th class="string">{{'global.pais' | translate}}</th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.PaisDenominacion.Denominacion.Des', 4)">
                          {{'mantenimientoRoyalties.table.denominacion' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.PaisDenominacion.Denominacion.Des')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.Marca.Des', 5)">
                          {{'mantenimientoRoyalties.table.marca' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.Marca.Des')"></i></div>
                        </th>
                        <th class="number sortable" (click)="toOrderBy('x=> x.Superficie_Fee', 6)">
                          {{'mantenimientoRoyalties.table.superficie' | translate}} {{ unidadesMedida ? "(" + unidadesMedida.divisas.symbol + ")" : "" }}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.Superficie_Fee')"></i></div>
                        </th>
                        <th class="number sortable" (click)="toOrderBy('x=> x.NPlantas_Fee', 7)">
                          {{'mantenimientoRoyalties.table.planta' | translate}} {{ unidadesMedida ? "(" + unidadesMedida.divisas.symbol + ")" : "" }}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.NPlantas_Fee')"></i></div>
                        </th>
                        <th class="number sortable sortable-biggest" (click)="toOrderBy('x=> x.KilosImpresosEfectivos_Productor_Fee', 8)">
                          {{'mantenimientoRoyalties.table.pesoProd' | translate}} {{ unidadesMedida ? "(" + unidadesMedida.divisas.symbol + ")" : "" }}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.KilosImpresosEfectivos_Productor_Fee')"></i></div>
                        </th>
                        <th class="number sortable sortable-biggest" (click)="toOrderBy('x=> x.KilosImpresosEfectivos_Etiquetador_Fee', 9)">
                          {{'mantenimientoRoyalties.table.pesoEtq' | translate}} {{ unidadesMedida ? "(" + unidadesMedida.divisas.symbol + ")" : "" }}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.KilosImpresosEfectivos_Etiquetador_Fee')"></i></div>
                        </th>
                        <th class="action">
                          <i class="fas fa-plus" app-click-stop-propagation (click)="create()" title="{{'mantenimiento-etiquetas.tituloNew' | translate}}"></i>
                        </th>
                    </tr>
                </thead>
                <tbody class="clickable" *ngFor="let royalty of royalties; let i=index; trackBy: trackByRoyaltyId">
                    <tr>
                        <td class="id">{{royalty.id}}</td>
                        <td class="string-overflow" title="{{royalty.desEntidadControl}}">{{royalty.desEntidadControl}}</td>
                        <td class="string">{{royalty.desPais}}</td>
                        <td class="string">{{royalty.desDenominacion}}</td>
                        <td class="string">{{royalty.desMarca}}</td>
                        <td class="number">{{royalty.superficie_Fee | number : '1.0-5' : defaultLanguage}}</td>
                        <td class="number">{{royalty.nPlantas_Fee | number : '1.0-5' : defaultLanguage}}</td>
                        <td class="number-longest">{{royalty.kilos_Productor_Fee | number : '1.0-5' : defaultLanguage}}</td>
                        <td class="number-longest">{{royalty.kilos_Etiquetador_Fee | number : '1.0-5' : defaultLanguage}}</td>
                        <td class="multi-actions">
                            <i class="fas fa-pencil-alt" (click)="update(royalty)" app-click-stop-propagation
                                title="{{'titles.editar' | translate}}"></i>
                            <i class="far fa-trash-alt" (click)="askDelete(royalty)" app-click-stop-propagation
                                title="{{'titles.eliminar' | translate}}"></i>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!royalties || (royalties && royalties.length < 1)">
                    <tr>
                        <td colspan="10">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
      </div>
      <app-paginator *ngIf="royalties && royalties.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
      <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event; showWarning=$event">
      </app-toast>
    </content>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{royaltyId ? ('mantenimientoRoyalties.tituloEdit' | translate) : ('mantenimientoRoyalties.tituloNew' |
                translate)}}
            </h4>
        </header>
        <app-mantenimiento-roy-new-edit [royaltyId]="royaltyId" [unidadesMedida]="unidadesMedida" [entidadesControl]="entidadesControl"
            (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-mantenimiento-roy-new-edit>
    </div>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
